module.exports = "/_next/static/images/se-1f642770ccba1a8f5948ac69923c15ba.svg";